module.exports = __webpack_public_path__ + "img/markdown-fill.2d51513e.svg";